module.exports = __webpack_public_path__ + "static/02-5a005bd6e50a92ebb852094e87bae405.jpg";